// extracted by mini-css-extract-plugin
export default {"statisticBreak":"StatsSection_statisticBreak__kS3+n","statisticText":"StatsSection_statisticText__1UwKj","source":"StatsSection_source__K7vhZ"};